let ua = navigator.userAgent;
let productLine = '';
let platform = '';
let urlProductLineReg = /product_line=(([\w\-]+))/gim;
let uaProductLineReg = /K\-Product\-Line:([\w\-]+);/gim;
let urlProductLineExec = urlProductLineReg.exec(location.search);
let uaProductLineExec = uaProductLineReg.exec(ua);

export const BROSWER = {
  //移动终端浏览器版本信息
  trident: ua.indexOf('Trident') > -1, //IE内核
  presto: ua.indexOf('Presto') > -1, //opera内核
  webKit: ua.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
  gecko: ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') == -1, //火狐内核
  isMobile: !!ua.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
  ios: !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
  android: ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1, //android终端或uc浏览器
  iPhone: ua.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
  iPad: ua.indexOf('iPad') > -1, //是否iPad
  webApp: ua.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部

  androidApp: ua.indexOf('kaoyanclub') > -1, // 旧 android App标识
  isApp: ua.indexOf('kmf_appinner') > -1 // App内标识
};

// 设置 product_line
productLine = urlProductLineExec ? urlProductLineExec[1] : uaProductLineExec ? uaProductLineExec[1] : '';

// 如果是移动端
if (BROSWER.isMobile) {
  platform = 'h5';

  // 如果是安卓 App
  if ((BROSWER.android && BROSWER.isApp) || BROSWER.androidApp) {
    platform = 'android';
  }
  // 如果是ios App
  if (BROSWER.ios && BROSWER.isApp) {
    platform = 'ios';
  }
} else {
  platform = 'web';
}

export const K_PARAMS = {
  'k-product-line': productLine,
  'k-platform': platform
};
